/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_End_TitleInputs */

const en_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain to Next Event`)
};

const fr_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enchainer a l'Evenement Suivant`)
};

const de_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum nächsten Ereignis`)
};

const it_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catena al prossimo evento`)
};

const ru_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цепочка к следующему событию`)
};

const es_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadena al siguiente evento`)
};

const zh_cn2_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链至下一个事件`)
};

const ja_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントへのチェーン`)
};

const hi_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले इवेंट से जुड़ें`)
};

const pt_pt2_snap_to_end_title = /** @type {(inputs: Snap_To_End_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadeamento para o próximo evento`)
};

/**
* | output |
* | --- |
* | "Chain to Next Event" |
*
* @param {Snap_To_End_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_end_title = /** @type {((inputs?: Snap_To_End_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_End_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_end_title(inputs)
	if (locale === "de") return de_snap_to_end_title(inputs)
	if (locale === "it") return it_snap_to_end_title(inputs)
	if (locale === "ru") return ru_snap_to_end_title(inputs)
	if (locale === "es") return es_snap_to_end_title(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_end_title(inputs)
	if (locale === "ja") return ja_snap_to_end_title(inputs)
	if (locale === "hi") return hi_snap_to_end_title(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_end_title(inputs)
	return en_snap_to_end_title(inputs)
});